<template>
  <div>
    <el-dialog
      :title="titleName"
      :visible="payVisibleProp"
      width="800px"
      @close="onClose"
      style="line-height: 0;"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="合并支付凭证订单" name="first" v-if="!isShow">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form
                style="margin-top:20px"
                :inline="false"
                :model="paySnForm"
                :rules="paySnRules"
                ref="paySnRef"
                label-width="130px"
                autocomplete="on"
                size="mini"
              >
                <el-form-item label="图片上传">
                  <!--            <div class="upload_group" style="margin-bottom:20px;">-->
                  <!--              <div class="upload_list" style="display: flex;flex-direction: row;justify-content: flex-start;">-->
                  <!--                <el-upload-->
                  <!--                    class="upload-demo"-->
                  <!--                    drag-->
                  <!--                    action="#"-->
                  <!--                    :auto-upload="false"-->
                  <!--                    :on-change="uploadFile"-->
                  <!--                    :file-list="fileList"-->
                  <!--                    :multiple=false-->
                  <!--                    :show-file-list=false-->
                  <!--                    :limit="1">-->
                  <!--                  <i class="el-icon-upload"></i>-->
                  <!--                  <div class="el-upload__text">将支付凭证拖到此处，或<em>点击上传</em></div>-->
                  <!--                </el-upload>-->
                  <!--                <img style="width: 180px;max-height: 180px;margin-left: 20px;border-radius: 5px;" @click="openWin('../../static/typeImg.html?typeImage=' + paySnForm.file_url)" v-if="paySnForm.file_url" :src="paySnForm.file_url" class="avatar"/>-->
                  <!--              </div>-->
                  <!--            </div>-->
                  <el-upload
                    class="uploader"
                    :auto-upload="false"
                    :show-file-list="false"
                    drag
                    :on-change="UploadImage"
                    action="#"
                  >
                    <i class="el-icon-upload" v-if="!paySnForm.file_url">
                      <span class="fontStyle1">
                        将支付凭证拖到此处，或
                        <span class="fontStyle2">点击上传</span>
                      </span>
                    </i>
                    <div
                      class="uploaded"
                      v-else
                      :style="{'background-image': 'url(' + paySnForm.file_url + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}"
                    >
                      <span class="fontStyle3">
                        <i
                          class="el-icon-zoom-in"
                          @click="openWin('../../static/typeImg.html?typeImage=' +paySnForm.file_url)"
                        >查看图片</i>
                        <i class="el-icon-delete-solid" @click.stop="delImg">删除图片</i>
                        <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
                      </span>
                    </div>
                  </el-upload>
                </el-form-item>

                <el-divider content-position="left">收款人信息</el-divider>
                <el-row :gutter="24">
                  <el-col :span="14">
                    <el-form-item label="收款人" size="mini">
                      <el-tooltip class="item" effect="dark" content="已复制" placement="right">
                        <el-input
                          placeholder="请输入收款人"
                          id="put"
                          @click.native="copy"
                          :readonly="true"
                          v-model="paySnForm.account"
                          type="text"
                        >
                          <span slot="suffix" style="color: #ff0000">可复制</span>
                        </el-input>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                  <el-col :span="14">
                    <el-form-item label="收款人开户行" size="mini">
                      <el-tooltip class="item" effect="dark" content="已复制" placement="right">
                        <el-input
                          width="500"
                          placeholder="请输入收款人开户银行"
                          id="put2"
                          @click.native="copy2"
                          v-model="paySnForm.account_bank_name"
                          type="text"
                        >
                          <span slot="suffix" style="color: #ff0000">可复制</span>
                        </el-input>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="收款账号" size="mini">
                      <el-tooltip class="item" effect="dark" content="已复制" placement="right">
                        <el-input
                          width="500"
                          placeholder="请输入收款人账号"
                          id="put1"
                          @click.native="copy1"
                          v-model="paySnForm.account_number"
                          type="text"
                        >
                          <span slot="suffix" style="color: #ff0000">可复制</span>
                        </el-input>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-divider content-position="left">付款人信息</el-divider>
                <el-row :gutter="24">
                  <el-col :span="10">
                    <el-form-item label="付款人开户行" size="mini">
                      <el-select
                        @change="changeShopPay"
                        v-model="paySnForm.payee_bank_name"
                        filterable
                        allow-create
                        placeholder="请选择付款开户银行"
                      >
                        <el-option
                          v-for="(item,index) in shopPayList"
                          :label="item.payer_bank"
                          :value="item.payer_bank"
                          :key="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <!--
              <el-form-item label="付款人开户行">
                <el-input v-model="paySnForm.payee_account_number" v-on:focus="showShopPayList"></el-input>
              </el-form-item>
                    -->
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="付款账号" size="mini">
                      <el-input
                        placeholder="请输入付款账号"
                        width="300"
                        v-model="paySnForm.payee_account_number"
                        type="text"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="付款人" size="mini">
                      <el-input
                        placeholder="请输入付款人"
                        width="300"
                        v-model="paySnForm.payee_account"
                        type="text"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="付款类型" size="mini">
                      <el-select width="300" v-model="paySnForm.pay_type" placeholder="请选择">
                        <el-option label="银行卡" :value="1"></el-option>
                        <el-option label="微信" :value="2"></el-option>
                        <el-option label="支付宝" :value="3"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-divider content-position="left"></el-divider>
                <el-row :gutter="24">
                  <!--
              <el-col :span="10">
                  <el-form-item label="是否对公" >
                      <el-select
                              width="300"
                              v-model="paySnForm.is_company"
                              placeholder="请选择">
                          <el-option label="对公" :value="1"></el-option>
                          <el-option label="净费" :value="0"></el-option>
                      </el-select>
                  </el-form-item>
                  </el-col>-->

                  <el-col :span="10">
                    <el-form-item label="凭证金额" size="mini">
                      <el-input
                        placeholder="请输入凭证金额"
                        width="300"
                        v-model="paySnForm.pay_money"
                        type="text"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="支付日期" size="mini" prop="pay_date">
                      <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        width="300"
                        v-model="paySnForm.pay_date"
                        placeholder="选择日期"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="系统流水号" size="mini">
                      <el-input
                        placeholder="请输入支付凭证流水号"
                        width="300"
                        v-model="getPay_sn"
                        type="text"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <!--            <el-col :span="10">-->
                  <!--                <el-form-item label="标题" size="mini" >-->
                  <!--                    <el-input placeholder="请输入标题"  width="300" v-model="paySnForm.title" type="text"></el-input>-->
                  <!--                </el-form-item>-->
                  <!--            </el-col>-->

                  <!--            <el-col :span="10">-->
                  <!--                <el-form-item label="大写金额" size="mini" >-->
                  <!--                    <el-input placeholder="请输入大写金额"  width="300" v-model="paySnForm.big_amount" type="text"></el-input>-->
                  <!--                </el-form-item>-->
                  <!--            </el-col>-->
                  <!--            <el-col :span="10">-->
                  <!--                <el-form-item label="小写金额" size="mini">-->
                  <!--                    <el-input placeholder="请输入小写金额"  width="300" v-model="paySnForm.small_amount" type="text"></el-input>-->
                  <!--                </el-form-item>-->
                  <!--            </el-col>-->
                  <el-col :span="10">
                    <el-form-item label="回单流水号" size="mini">
                      <el-input
                        placeholder="请输入银行回单流水号"
                        width="300"
                        v-model="paySnForm.bank_receipt_sn"
                        type="text"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="回单编号" size="mini">
                      <el-input
                        placeholder="请输入回单编号"
                        width="300"
                        v-model="paySnForm.receipt_sn"
                        type="text"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <!--            <el-col :span="10">-->
                  <!--                <el-form-item label="摘要" size="small">-->
                  <!--                    <el-input placeholder="请输入摘要"  width="300" v-model="paySnForm.bank_desc" type="text"></el-input>-->
                  <!--                </el-form-item>-->
                  <!--            </el-col>-->
                  <!--            <el-col :span="10">-->
                  <!--                <el-form-item label="用途" size="mini">-->
                  <!--                    <el-input placeholder="请输入用途"  width="300" v-model="paySnForm.bank_use" type="text"></el-input>-->
                  <!--                </el-form-item>-->
                  <!--            </el-col>-->
                  <el-col :span="10">
                    <el-form-item label="回单交易日期" size="mini" prop="bank_date">
                      <el-date-picker
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        width="300"
                        v-model="paySnForm.bank_date"
                        placeholder="选择日期"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>

                  <el-col :span="10">
                    <el-form-item label="备注" size="mini" prop="remark">
                      <el-input
                        width="300"
                        placeholder="请输入备注"
                        v-model="paySnForm.remark"
                        autosize
                        type="textarea"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-row :gutter="24">
                <el-col :span="24" :offset="15">
                  <el-button size="mini" @click="close()">取消</el-button>
                  <el-button size="mini" type="success" @click="paySnFormSubmit()">确认</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="微信二维码支付" name="second">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form size="mini">
                <el-form-item label="友情提示 : ">
                  当天订单请于
                  <span class="redStyle">16：00</span>前完成扫码支付！
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form size="mini">
                <el-form-item label="订单金额 : ">{{paySnForm.pay_money}}（元）</el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <img
                :src="qrcodeWxUrl"
                alt="微信二维码支付"
                v-show="qrcodeWxUrl"
                style="width: 164px;height: 164px;"
              />
              <el-button size="mini" type="success" @click="receiveFormSubmit(2)">生成微信二维码支付</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="die_time">
            <el-col :span="24">
              <el-form size="mini" class="redStyle">
                <el-form-item label="支付截止时间 : ">{{die_time}}</el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="支付宝二维码支付" name="third">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form size="mini">
                <el-form-item label="友情提示 : ">
                  当天订单请于
                  <span class="redStyle">16：00</span>前完成扫码支付！
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form size="mini">
                <el-form-item label="订单金额 : ">{{paySnForm.pay_money}}（元）</el-form-item>
              </el-form>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="24">
              <img
                :src="qrcodeAliUrl"
                alt="支付宝二维码支付"
                v-show="qrcodeAliUrl"
                style="width: 164px;height: 164px;"
              />
              <el-button size="mini" type="success" @click="receiveFormSubmit(1)">生成支付宝二维码支付</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="die_time2">
            <el-col :span="24">
              <el-form size="mini" class="redStyle">
                <el-form-item label="支付截止时间 : ">{{die_time2}}</el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <el-dialog :visible.sync="dialogFormVisible2">
      <el-table :data="shopPayList">
        <el-table-column label="选择" align="center" min-width="20%">
          <template slot-scope="scope">
            <el-radio :label="scope.$index" @change.native="getCurrentRow(scope.row)">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="payer_account" label="付款人" min-width="20%"></el-table-column>
        <el-table-column prop="payer_bank" label="开户行" min-width="20%"></el-table-column>
        <el-table-column prop="shop_name" label="shop_name" min-width="20%"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 全局遮罩 图片上传 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
    >
      <div class="loading-overlay">
        <div class="loading-spinner" style="font-size:30px;font-weight: bold">
          <i class="el-icon-upload"></i>
          文件上传ing
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import imgCompressUtil from "../../utils/imgCompressUtil";
import QRCode from "qrcode";
export default {
  name: "ePay",
  props: {
    payVisibleProp: {
      type: Boolean,
      default: false,
    },
    titleName:{
      type: String,
      default: '',
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    orderInfoProp: {
      type: Object,
      default: () => ({}),
    },
    collectionPayinfo: {
      default: () => ({}),
    },
  },
  data() {
    return {
      num: 0,
      die_time: "",
      die_time2: "",
      activeName: "first", // 初始化 activeName 属性
      dialogFormVisible2: false,
      collectionPay: {},
      orderInfo: {},
      fileUploadList: [],
      dialogImageUrl: "",
      getPay_sn: "",
      paySnForm: {
        payee_account: "",
        payee_account_number: "",
        payee_bank: "",
        file_url: "",
        shop_pay_id: 1,
        pay_type: "",
        pay_money: "",
        account: "", //收款人
        account_number: "",
        account_bank_name: "",
      },
      currM: "",
      mList: [],
      total: 0,
      // title: "车辆选择",
      car_number: "",
      fileList: [],
      paySnRules: {
        pay_date: [
          { required: true, message: "请输入支付日期", trigger: "blur" },
        ],
      },
      shopPayList: [],
      //二维码
      qrcodeWxUrl: "",
      qrcodeAliUrl: "",
      pay_id: "",
      timerId: null,
      dialogVisible: false,
    };
  },
  created() {
    //this.getCarList();
    //console.log('orderInfo--------',this.orderInfo);
    if (this.collectionPayinfo.length > 0) {
      this.collectionPay = JSON.parse(this.collectionPayinfo);
      if (this.collectionPay) {
        this.paySnForm.account = this.collectionPay.payee_account;
        this.paySnForm.account_number = this.collectionPay.payee_account_number;
        this.paySnForm.account_bank_name = this.collectionPay.payee_bank;
        //this.paySnForm.pay_money=newVal.total_money;
        this.paySnForm.shop_id = this.collectionPay.shop_id;
        this.getShopPayList();
      }
      //this.paySnForm.corp_id=newVal.corp_id;
    }
  },
  methods: {
    getTime(time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
      var mi =
        date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
      var s =
        date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
      return y + "-" + m + "-" + d + " " + h + ":" + mi + ":" + s;
    },
    //点击切换tab
    handleClick(tab, event) {
      // //console.log(tab, event);
    },
    openWin(url) {
      var name; //网页名称，可为空;
      var iWidth = 500; //弹出窗口的宽度;
      var iHeight = 570; //弹出窗口的高度;
      //window.screen.height获得屏幕的高，window.screen.width获得屏幕的宽
      var iTop = (window.screen.height - 30 - iHeight) / 2; //获得窗口的垂直位置;
      var iLeft = (window.screen.width - 10 - iWidth) / 2; //获得窗口的水平位置;
      window.open(
        url,
        name,
        "height=" +
          iHeight +
          ",innerHeight=" +
          iHeight +
          ",width=" +
          iWidth +
          ",innerWidth=" +
          iWidth +
          ",top=" +
          iTop +
          ",left=" +
          iLeft +
          ",toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no"
      );
    },
    showShopPayList() {
      this.dialogFormVisible2 = true;
    },
    //选择付款账户
    getCurrentRow(e) {
      //console.log(e)
      this.paySnForm.payee_bank_name = e.payer_bank; //付款人开户银行
      this.paySnForm.payee_account = e.payer_account;
      this.paySnForm.payee_account_number = e.payer_account_number;
      this.paySnForm.shop_pay_id = e.id;
      this.dialogFormVisible2 = false;
    },
    changeShopPay(val) {
      ////console.log(val)
      this.shopPayList.forEach((item) => {
        if (item.payer_bank === val) {
          ////console.log(item.plate_number) // 打印输出了label、value值 plate_number
          this.paySnForm.payee_bank_name = item.payer_bank; //付款人开户银行
          this.paySnForm.payee_account = item.payer_account;
          this.paySnForm.payee_account_number = item.payer_account_number;
          this.paySnForm.shop_pay_id = item.id;
        }
      });
    },
    UploadImage(file) {
      let _this = this;
      _this.dialogVisible = true;
      this.paySnForm.file_url = URL.createObjectURL(file.raw);
      //console.log('UploadImage-file',file)
      let payFd = new FormData();
      payFd.append("file", file.raw);
      payFd.append("file_type", 1);
      payFd.append("company_id", sessionStorage.getItem("company_id"));
      payFd.append("access_token", sessionStorage.getItem("token"));
      this.$axios
        .ossUploadFile(payFd)
        .then((res) => {
          if (res.code == 200) {
            _this.paySnForm.file_url = res.data.src;
            this.$message.success(res.msg);
            _this.dialogVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => console.log("UploadImage-error", error));
    },
    delImg() {
      this.paySnForm.file_url = "";
    },
    getShopPayList() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
      };
      // if(this.orderInfo && this.orderInfo.shop_id) param.shop_id = this.orderInfo.shop_id
      this.$axios
        .shopPayList(param)
        .then((res) => {
          if (res.code == 200) {
            //console.log('shopPay-----',res.data)
            this.shopPayList = res.data;
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    copy() {
      var d = document.getElementById("put"); //获取需要复制的元素
      d.select(); //选中
      document.execCommand("copy"); //直接复制

      //打印结果： 点击我试试！
    },
    copy1() {
      var d = document.getElementById("put1"); //获取需要复制的元素
      d.select(); //选中
      document.execCommand("copy"); //直接复制

      //打印结果： 点击我试试！
    },
    copy2() {
      var d = document.getElementById("put2"); //获取需要复制的元素
      d.select(); //选中
      document.execCommand("copy"); //直接复制

      //打印结果： 点击我试试！
    },
    getCarList() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
      };
      this.$axios
        .carList(param)
        .then((res) => {
          if (res.code == 200) {
            this.mList = res.data.data;
            this.total = res.data.total;
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    onClose() {
      //this.$emit('eventPay',false)
      this.clearTimer();
      this.$emit("update:payVisibleProp", false);
    },
    close() {
      this.$emit("update:payVisibleProp", false);
    },
    ok() {},
    uploadSuccess(response, file, fileList) {
      // 上传成功后，重置el-upload组件
      this.$refs.upload.clearFiles();
      this.fileList = fileList;
      //console.log('88888------',item.raw)
    },
    uploadFile(item) {
      let _this = this;

      // this.imageUrl = URL.createObjectURL(item.raw);
      let file = item.raw;
      _this.paySnForm.file_url = item.raw;
      // //console.log('base64--------',res);
      //行驶证识别
      //------上传到阿里云
      let carFd = new FormData();
      carFd.append("file", item.raw);
      carFd.append("file_type", 1);
      //  carFd.append('file_value', this.addForm.vin)
      carFd.append("company_id", sessionStorage.getItem("company_id"));
      carFd.append("access_token", sessionStorage.getItem("token"));
      this.$axios
        .ossUploadFile(carFd)
        .then((res11) => {
          //console.log('aliyun--------',res11)
          if (res11.code == 200) {
            this.$message.success(res11.msg);
            this.paySnForm.file_url = res11.data.src;

            //console.log('file_url--------',this.paySnForm.file_url)
          } else if (res11.code == 1) {
            this.$message.error(res11.msg);
          }
        })
        .catch(function (error) {
          //console.log(error);
        });
      //------上传到阿里云
      //行驶证识别

      this.fileList = [];
    },
    paySnFormSubmit() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        file_url: this.paySnForm.file_url,
        remark: this.paySnForm.remark,
        shop_id: this.paySnForm.shop_id,
        shop_pay_id: this.paySnForm.shop_pay_id,
        orderIDs: [],
        pay_date: this.paySnForm.pay_date,
        bank_date: this.paySnForm.bank_date,
        pay_type: this.paySnForm.pay_type,
        is_company: 0,
        corp_id: 0,
        pay_money: this.paySnForm.pay_money,
        bank_receipt_sn: this.paySnForm.bank_receipt_sn,
        receipt_sn: this.paySnForm.receipt_sn,
        account: this.paySnForm.account, //收款人
        account_number: this.paySnForm ? this.paySnForm.account_number : "",
        account_bank_name: this.paySnForm
          ? this.paySnForm.account_bank_name
          : "",
        payee_bank_name: this.paySnForm ? this.paySnForm.payee_bank_name : "", //付款人开户银行
        payee_account: this.paySnForm ? this.paySnForm.payee_account : "",
        payee_account_number: this.paySnForm
          ? this.paySnForm.payee_account_number
          : "",
      };
      if (this.collectionPayinfo.length <= 0) {
        param.is_company = 1;
        param.corp_id = this.paySnForm.corp_id;
      }
      if (this.orderInfo.orderIDs) {
        param.orderIDs = this.orderInfo.orderIDs;
      } else {
        for (var i in this.orderInfo) {
          param.orderIDs.push(this.orderInfo[i].order_id);
        }
      }
      ////console.log('payParam-------',param)
      this.$axios
        .mergeShopPay(param)
        .then((res) => {
          ////console.log('pay rs------',res)
          if (res.code == 200) {
            this.$message.success("支付成功");
            this.$emit("update:payVisibleProp", false);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          //console.log(error);
        });
      this.$emit("eventPay", this.paySnForm.shop_id, this.paySnForm.corp_id);
    },
    receiveFormSubmit(type) {
      if (this.isShow) {
        //对公扫码付款
        this.payScan(type);
      } else {
        this.pay(type);
      }
    },
    payScan(type) {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        orderIDs: [],
        pay_way: 1,
      };
      if (type == 2) {
        param.pay_way = 1;
      } else {
        param.pay_way = 2;
      }
      if (this.orderInfo.orderIDs) {
        param.order_ids = this.orderInfo.orderIDs;
      } else {
        for (var i in this.orderInfo) {
          param.order_ids.push(this.orderInfo[i].order_id);
        }
      }
      this.$axios.getScanpay(param).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.$emit("update:payVisibleProp", false);
          // const url = res.data.url;
          // QRCode.toDataURL(url, (err, url) => {
          //   if (err) {
          //     console.error(err);
          //     return;
          //   }
          //   if (type == 2) {
          //     this.qrcodeWxUrl = url;
          //     this.die_time = this.getTime(res.data.expiredTime * 1000);
          //   } else if (type == 1) {
          //     this.qrcodeAliUrl = url;
          //     this.die_time2 = this.getTime(res.data.expiredTime * 1000);
          //   }
          // });
          // this.pay_id = res.data.pay_id;
          // if (this.pay_id) {
          //   this.timerId = setInterval(this.rollPollShopPay, 10000);
          // }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    pay(type) {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        orderIDs: [],
        pay_way: 1,
      };
      if (this.orderInfo.orderIDs) {
        param.orderIDs = this.orderInfo.orderIDs;
      } else {
        for (var i in this.orderInfo) {
          param.orderIDs.push(this.orderInfo[i].order_id);
        }
      }
      if (type == 2) {
        param.pay_way = 2;
      }
      this.$axios.receiveMergeShopPay(param).then((res) => {
        if (res.code == 200) {
          const url = res.data.url;
          QRCode.toDataURL(url, (err, url) => {
            if (err) {
              console.error(err);
              return;
            }
            if (type == 2) {
              this.qrcodeWxUrl = url;
              this.die_time = this.getTime(res.data.expiredTime * 1000);
            } else if (type == 1) {
              this.qrcodeAliUrl = url;
              this.die_time2 = this.getTime(res.data.expiredTime * 1000);
            }
          });
          this.pay_id = res.data.pay_id;
          if (this.pay_id) {
            this.timerId = setInterval(this.rollPollShopPay, 10000);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    clearTimer() {
      clearInterval(this.timerId); // 清除定时器
    },
    //根据pay_id获取支付状态
    async rollPollShopPay() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        pay_id: this.pay_id,
      };
      this.$axios
        .rollPollShopPay(param)
        .then((res) => {
          //console.log('rollPollShopPay rs------',res)
          if (res.code == 200) {
            if (res.data.status == 1) {
              this.$message.success("支付成功");
              this.$emit("update:payVisibleProp", false);
              // this.$router.push('/insuranceSysTeamOrder')
              setTimeout(() => {
                window.location.href = "insuranceSysTeamOrder";
              }, 3000);
            } else if (res.data.status == 0) {
              this.$message.error(res.msg);
              this.num++;
              //console.log('num',this.num)
              if (this.num == 9) {
                this.clearTimer();
                this.$message.error("支付失败，请重新选择");
                setTimeout(() => {
                  window.location.href = "insuranceSysTeamOrder";
                }, 3000);
              }
            } else if (res.data.status == 2) {
              this.pay_id = "";
              this.$message.error("支付失败，请重新选择");
              setTimeout(() => {
                window.location.href = "insuranceSysTeamOrder";
              }, 3000);
            }
          } else {
            this.$message.error(res.msg);
            this.clearTimer();
          }
        })
        .catch((error) => {
          //console.log(error);
          this.clearTimer();
        });
    },
  },
  beforeDestroy() {
    this.clearTimer();
  },
  watch: {
    isShow: {
      handler(newVal, oldVal) {
        console.log(newVal,'newVal')
        if (newVal) {
          this.activeName = "second";
        }else{
          this.activeName = "first";
          
        }
      },
    },
    orderInfoProp: {
      handler(newVal, oldVal) {
        this.orderInfo = newVal;
        if (this.collectionPayinfo.length == undefined) {
          this.paySnForm.account = newVal.payee_account;
          this.paySnForm.account_number = newVal.payee_account_number;
          this.paySnForm.account_bank_name = newVal.payee_bank;
          this.paySnForm.pay_money = newVal.total_money;
          this.paySnForm.shop_id = newVal.shop_id;
          this.paySnForm.corp_id = newVal.corp_id;
          this.getShopPayList();
        } else {
          //循环计算订单费用 sell_price
          this.paySnForm.pay_money = newVal.total_money;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="less" scoped>
.upload-demo {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.upload_group {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .upload_list {
    width: 180px;
    margin-right: 1rem;
  }

  /deep/.el-upload-dragger .el-upload__text {
    font-size: 10px;
    color: #409eff;
  }

  /deep/.el-icon-upload:before {
    width: 40px !important;
    height: 40px !important;
  }

  .upload_list:last-child {
    margin-right: 0;
  }

  /deep/.el-upload-dragger {
    width: 100%;
    height: auto;
    padding: 20px 0;
    //border: 1px solid #999;
  }

  /deep/.el-upload {
    width: 100%;
  }

  /deep/.el-upload-dragger .el-icon-upload {
    margin: 10px 0;
  }
}
.table_name:hover {
  color: #409eff;
  cursor: pointer;
}
/deep/.el-dialog,
.el-dialog__body {
  height: auto;
}
.redStyle {
  color: red;
}
.fontStyle1 {
  display: block;
  font-size: 16px;
  color: #606266;
}
.fontStyle2,
.fontStyle3 {
  font-size: 16px;
  color: #3a8ee6;
}
.fontStyle3 {
  font-size: 22px;
  color: #999;
  position: absolute;
  bottom: 1px;
  right: 1px;
}
</style>



// WEBPACK FOOTER //
// src/view/common/ePay.vue